import config from '../../config';
import API from '../api';

const getRequestId = () =>
  crypto.randomUUID ? crypto.randomUUID() : `${Date.now()}-${Math.random().toString(16).slice(2)}`;

/**
 * Executes a server-owned analytics view.
 * @param {string} viewId - Analytics view ID.
 * @param {Object} request - View scope, period, selection, and optional filters.
 * @returns {Promise<Object>} Typed analytics view response.
 */
const getAnalyticsViewData = async (viewId, request) => {
  await API.refreshTokenWhenNeeded();
  const url = `${config.queryApi.baseUrl}/analytics/views/${viewId}:getData`;

  return fetch(url, {
    method: 'POST',
    headers: { ...API.headers, 'x-adm-request-id': getRequestId() },
    body: JSON.stringify({ viewId, viewVersion: 'v1', ...request })
  }).then(res => API.generateResponse(res));
};

export { getAnalyticsViewData };
